/**
 * @generated SignedSource<<f647f64c49d6e11322c76e1343875dec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SignalFocusScreen_widgetSignalOverview$data = {
  readonly id: string;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"SignalFocusScreenListHeader_widgetSignalOverview" | "WidgetSignalOverviewContentMediumPaginated">;
  readonly " $fragmentType": "SignalFocusScreen_widgetSignalOverview";
};
export type SignalFocusScreen_widgetSignalOverview$key = {
  readonly " $data"?: SignalFocusScreen_widgetSignalOverview$data;
  readonly " $fragmentSpreads": FragmentRefs<"SignalFocusScreen_widgetSignalOverview">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SignalFocusScreen_widgetSignalOverview",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SignalFocusScreenListHeader_widgetSignalOverview"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetSignalOverviewContentMediumPaginated"
    }
  ],
  "type": "WidgetSignalOverview",
  "abstractKey": null
};

(node as any).hash = "8d3e2c2a86b25f52bd69a67c5d38cdc0";

export default node;
